import React from "react";
import logo_next_days from "../../img/password.png";
import { Formik } from "formik";
import {
  messageError,
  messageSuccess,
  userOTP,
  userPhoneNumber,
  valiDate,
} from "../../helper";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { CHANGE_PASSWORD } from "./apollo";
export default function ChangePasswordUser() {
  const history = useHistory();

  const [changePassword] = useMutation(CHANGE_PASSWORD);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  return (
    <Formik
      initialValues={{
        password: "",
        ConFirmPassword: "",
      }}
      enableReinitialize={false}
      validate={(values) => {
        const errors = {};
        if (!values.password) {
          errors.password = "ກະລຸນາປ້ອນລະຫັດຜ່ານກ່ອນ!";
        }
        if (!values.ConFirmPassword) {
          errors.ConFirmPassword = "ກະລຸນາຢືນຢັນລະຫັດຜ່ານກ່ອນ!";
        }
          if (values?.password) {
            const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
            if (!regex.test(values.password)) {
              errors.password = "ລະຫັດຕ້ອງມີຕົວອັກສອນ ແລະ ຕົວເລກ ປົກກັນຢ່າງນ້ອຍ 6 ຕົວ";
            }
          }
          if (values?.ConFirmPassword) {
            const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
            if (!regex.test(values.ConFirmPassword)) {
              errors.ConFirmPassword = "ລະຫັດຕ້ອງມີຕົວອັກສອນ ແລະ ຕົວເລກປົກກັນຢ່າງນ້ອຍ  6 ຕົວ";
            }
          }

        if (
          values?.ConFirmPassword &&
          String(values?.ConFirmPassword)?.length < 6
        ) {
          errors.ConFirmPassword =
            "ກະລຸນາປ້ອນຢ່າງໜ້ອຍ 8 ໂຕເລກ " +
            String(values?.ConFirmPassword)?.length +
            " ຕົວເລກ";
        }
        if (values?.password && String(values?.password)?.length < 6) {
          errors.password =
            "ກະລຸນາປ້ອນຢ່າງໜ້ອຍ 6 ໂຕເລກ " +
            String(values?.password)?.length +
            " ຕົວເລກ";
        }
        if (values?.password !== values.ConFirmPassword) {
          errors.ConFirmPassword = "ລະຫັດຜ່ານບໍ່ຕົງກັນ";
        }
        return errors;
      }}
      onSubmit={async (values, { resetForm }) => {
        // console.log("values",values)
        try {
          let { data: _changePassword } = await changePassword({
            variables: {
              data: {
                password: String(values.password),
              },
              where: {
                otp: parseInt(userOTP()),
                phone_number: parseInt(userPhoneNumber()),
              },
            },
          });
          if (_changePassword?.changePassword?.status === "success") {
            messageSuccess("ຂໍລະຫັດສຳເລັດແລ້ວ");
            setTimeout(async () => {
              window.open(`https://nextday.anousith.express`);
            }, 2000);
            history.push("/success/user");
            resetForm();
          }
        } catch (error) {
          console.log(error);
          messageError("ການບັນທືກຂໍ້ມູນຜິດພາດ");
        }
      }}
    >
      {({
        values,
        errors,
        handleChange,
        handleSubmit,
        submitCount,

        /* and other goodies */
      }) => (
        <>
          <div className="mt-5">
            <div className="card">
              <div className="card-body">
                <center>
                  <img
                    src={logo_next_days}
                    className="mt-3"
                    style={{
                      width: 150,
                      height: 150,
                    }}
                  />
                </center>
                <h2 className="text-center fw-bolder text-danger p-2">
                  ສ້າງລະຫັດຜ່ານໃໝ່ {valiDate}
                </h2>
                <div className="form-group mb-2">
                  <label>ປ້ອນລະຫັດຜ່ານ *</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      className={
                        errors.password
                          ? "form-control is-invalid"
                          : "form-control invalid"
                      }
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      placeholder="********"
                      style={{
                        borderRadius: "10px",
                        height: "50px",
                        fontSize: "20px",
                        paddingRight: "40px"
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "20px"
                      }}
                      tabIndex={-1}
                    >
                      {showPassword ? "👁️" : "👁️‍🗨️"}
                    </button>
                  </div>
                  <span className="text-danger">{errors.password}</span>
                </div>

                <div className="form-group mb-2">
                  <label>ຢືນຢັນລະຫັດຜ່ານ *</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className={
                        errors.ConFirmPassword
                          ? "form-control is-invalid"
                          : "form-control invalid"
                      }
                      name="ConFirmPassword"
                      value={values.ConFirmPassword}
                      onChange={handleChange}
                      placeholder="********"
                      style={{
                        borderRadius: "10px",
                        height: "50px",
                        fontSize: "20px",
                        paddingRight: "40px"
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "20px"
                      }}
                      tabIndex={-1}
                    >
                      {showConfirmPassword ? "👁️" : "👁️‍🗨️"}
                    </button>
                  </div>
                  <span className="text-danger">{errors.ConFirmPassword}</span>
                  <br />
                </div>

                <button
                  type="button"
                  className="btn btn-success btn-block btn-lg"
                  onClick={() => handleSubmit()}
                  style={{ borderRadius: "10px" }}
                >
                  <i className="icon-check-circle" /> ຢືນຢັນປ່ຽນລະຫັດຜ່ານ
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Formik>
  );
}
